<script setup name="TvbBackTop">
import { inject, watch, ref } from 'vue'
import { useWindowScroll, useWindowSize } from '@vueuse/core'
import { useRoute } from 'vue-router'

const { x, y } = useWindowScroll()
const { width, height } = useWindowSize()
const size = inject('size')
const show = ref(false)
const bottom = ref(0)
const route = useRoute()

watch([x, y, width, height], () => {
  if (['videoDetail', 'videoPreview'].includes(route.name)) {
    show.value = false
    return
  }
  show.value = height.value * 0.8 < y.value
  if (width.value > 786) {
    const footerClientRect = document.querySelector('.tvb-footer').getBoundingClientRect()
    const bottomDiff = height.value - footerClientRect.top
    if (bottomDiff > 0) {
      bottom.value = bottomDiff
    } else {
      bottom.value = 0
    }
  } else {
    bottom.value = 0
  }
})

const backTop = () => {
  window.scroll({ behavior: 'smooth', top: 0, left: 0 })
}
</script>

<template>
  <div
    :style="{ '--bottom-diff': `${bottom}px` }"
    class="tvb-back-top"
    @click="backTop"
    :class="{ show: show, [size]: size }"
  >
    <tvb-svg-icon name="arrow_top" />
    <!-- <tvb-svg-icon name="icon_top_blue" /> -->
  </div>
</template>

<style lang="scss" scoped>
.tvb-back-top {
  background: #f5f6f7;
  border-radius: 0;
  opacity: 1;
  border: 0 solid rgba(236, 239, 243, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  right: 0;
  bottom: 16px;
  transition: background 0.15s linear;
  z-index: 99;
  border-radius: 999px 0 0 999px;
  background: var(--white-ffffff, #fff);
  width: 38px;
  height: 32px;
  box-shadow: 0 4px 14px 0 rgba(0, 0, 0, 0.1);
  transform: translateX(50px);
  transition: transform 0.5s ease;

  &.show {
    transform: translateX(0);
    visibility: visible;
    transition: transform 0.5s ease;
  }
  &.s,
  &.xs {
    width: 32px;
    height: 28px;
    bottom: 32px;
    svg {
      width: 14px;
      height: 14px;
    }
  }

  &:active {
    opacity: 0.75;
  }

  svg {
    width: 16px;
    height: 16px;
  }

  &:hover {
    cursor: pointer;
    background: #eceff3;
  }
}
</style>
